import { useEffect, useState } from 'react'

/**
 * Лёгкий глобальный стор «какой трек сейчас анализируется» (describe — синхронный,
 * запускается из кабинета). Нужен, чтобы СПИСОК (SunoTrackList) показал лоадинг-
 * пилюлю на строке трека во время анализа: describeBusy в useDescribe локальный
 * (виден только в кабинете). Без провайдера/контекста — модуль-стор + подписка
 * (анализ короткий и transient, полноценный jobs-контекст избыточен).
 */
const ids = new Set<string>()
const listeners = new Set<() => void>()

export const describingStore = {
	start(id: string) { ids.add(id); listeners.forEach((l) => l()) },
	end(id: string) { ids.delete(id); listeners.forEach((l) => l()) },
	has(id: string) { return ids.has(id) },
	subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l) } },
}

/** Идёт ли анализ для этого трека — для лоадинг-пилюли в списке/кабинете. */
export function useIsDescribing(id: string): boolean {
	const [running, setRunning] = useState(() => describingStore.has(id))
	useEffect(() => {
		const update = () => setRunning(describingStore.has(id))
		update()
		return describingStore.subscribe(update)
	}, [id])
	return running
}

/** Множество анализируемых треков — для кабинета (проверка per-версия без
 *  хука-на-каждую-версию: один хук, .has(v.id) в рендере). */
export function useDescribingSet(): ReadonlySet<string> {
	const [snap, setSnap] = useState<ReadonlySet<string>>(() => new Set(ids))
	useEffect(() => describingStore.subscribe(() => setSnap(new Set(ids))), [])
	return snap
}
